import { useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

export function useCartPersistence() {
  const { loadCartSummary } = useCart();
  const { isAuthenticated } = useAuth();

  // Auto-refresh cart summary periodically
  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      loadCartSummary();
    }, 60000); // Refresh every minute

    return () => clearInterval(interval);
  }, [isAuthenticated, loadCartSummary]);

  // Refresh cart when browser tab becomes visible
  useEffect(() => {
    if (!isAuthenticated) return;

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        loadCartSummary();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [isAuthenticated, loadCartSummary]);
}